import React, { useContext } from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import { CheckboxTable } from "../../view/CheckboxTable";
import ConfigChangesTableRow from "./ConfigChangesTableRow";
import ConfigChangesTableRowSkeleton from "./ConfigChangesTableRowSkeleton";
import { useConfigChangeTableHelper } from "./useConfigChangeTableHelper";
import { TableContext } from "../../index";

function ConfigChangesTable({ configChangesResult = [] }) {

    const configChangeTableHelper = useConfigChangeTableHelper();
    const { config } = useContext(TableContext);

    // Client-side filtering based on searchTerm from context
    const filteredResults = configChangesResult.filter((item) => {
        const term = (config.searchTerm || '').toLowerCase();
        if (!term) return true;

        const device = (item.device || '').toLowerCase();
        const ip = (item.ip || '').toLowerCase();
        const user = (item.user || '').toLowerCase();
        const date = item.changeDate
            ? new Date(Number(item.changeDate)).toLocaleString().toLowerCase()
            : '';

        return device.includes(term) || ip.includes(term) || user.includes(term) || date.includes(term);
    });

    const headers = [
        { name: 'Device', sortKey: 'device', onClick: () => configChangeTableHelper.onDeviceClick() },
        { name: 'IP ADDRESS', sortKey: 'ip', onClick: () => configChangeTableHelper.onIPClick() },
        { name: 'User', sortKey: 'user', onClick: () => configChangeTableHelper.onUserClick() },
        { name: 'Date', sortKey: 'changeDate', onClick: () => configChangeTableHelper.onDateClick() },
    ]

    return (
        <>
            <CheckboxTable className="mt-4" headers={headers} elements={filteredResults}>
                {config.isLoading ? (
                    Array.from(new Array(10)).map((_, index) => (
                        <ConfigChangesTableRowSkeleton key={index} index={index} />
                    ))
                ) : (
                    filteredResults.map((configChangeResult, index) => <ConfigChangesTableRow key={index} data={configChangeResult} index={index} />)
                )}
            </CheckboxTable>
            {!config.isLoading && filteredResults.length === 0 && (
                <div className="oct_empty-state-v2">
                    <div className="oct_empty-state-title">No records found</div>
                    <div>Try adjusting your search or filters to find what you're looking for.</div>
                </div>
            )}
        </>
    );
}

function mapStateToProps(state) {
    debug("ConfigChangesTable mapStateToProps", state);
    const configChangesPage = state.configChangesPage;
    return {
        configChangesResult: configChangesPage.configChangesResult || []
    };
}

export default connect(mapStateToProps)(ConfigChangesTable);
